import { useLayoutEffect, useState } from 'react';
import HandleChange from '../../../../../Helpers/HandleChange';
import {CATEGORY_TYPE, EQUIPMENT_AND_MATERIAL_MODEL} from '../Model/Model';
import { useTranslation } from 'react-i18next';
import { PHOTO_PICKER_MODEL } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import defaultImage from '../../../../../assets/IconsTables/ic-tools.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../../Routes/routes';
import { CreateEquipment } from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { toast } from 'react-toastify';
import { errorMsg } from '../../../../../Apis/functions';
import {
    createCategoryOrSubcategory,
    getCreateCategoryBody,
    getCreateSubcategoryBody,
    searchCategories,
    searchSubcategories,
    uploadEquipmentImage,
} from './CommonEquipmentMaterialApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CreateEquipmentMaterialApp = () => {
    // Holds the list of step labels displayed in the stepper
    const [steps, setSteps] = useState([]);
    // Tracks the currently active step in the form process
    const [activeStep, setActiveStep] = useState(0);
    // Flag used to trigger validation display when required fields are empty
    const [emptyFields, setEmptyFields] = useState(false);
    // Main model holding all equipment/material form data
    const [item, setItem] = useState({ ...EQUIPMENT_AND_MATERIAL_MODEL });
    // Generic input handler based on model structure
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    // Stores image data for the photo picker component
    const [photoPickerFile, setPhotoPickerFile] = useState({ ...PHOTO_PICKER_MODEL, preview: defaultImage });
    // Retrieves user permission from Redux store
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    // Controls component-level disabled states
    const [disabled, setDisabled] = useState();
    // Tracks overall form validity
    const [isValid, setIsValid] = useState(true);
    // Translation hook
    const { t } = useTranslation();
    // Router navigation
    const navigate = useNavigate();
    // Redux dispatcher
    const dispatch = useDispatch();
    // Options for dropdowns such as categories or subcategories
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    // Selected main category
    const [selectedCategory, setSelectedCategory] = useState([]);
    // Selected subcategory
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    // Changes the active step in the stepper
    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    // Navigates back to the equipment/material list screen
    const handleOnBack = () => {
        navigate(routes.equipmentAndMaterial.list);
    };
    // Validates and prepares request body when creating a new record
    const handleCreate = async () => {
        const body = item.toRegister({
            categoryId: selectedCategory?.[0]?.id || null,
            subCategoryId: selectedSubCategory?.[0]?.id || null,
            contractorId,
        });

        dispatch(CreateEquipment(body)).then(async ({ payload }) => {
            const { data } = payload;
            const { success, code, data: equipment } = data;

            if (!success) {
                errorMsg(code);
                return;
            }

            if(photoPickerFile?.fileSelected)
                await uploadEquipmentImage({
                    equipmentId: equipment.id,
                    fileSelected: photoPickerFile?.fileSelected,
                    selfieSrc: photoPickerFile?.selfieSrc,
                    dispatch,
                });

            toast.success(t('has_been_created_successfully'));
            navigate(routes.equipmentAndMaterial.list);
        });
    };

    // Initializes the step titles based on the active language
    useLayoutEffect(() => {
        setSteps([t('general_details'), t('technical_details'), t('add_photo'), t('summary')]);
    }, [permission, t]);

    // Clears all general details fields
    const handleClearGerneralDetails = () => {
        setItem(EQUIPMENT_AND_MATERIAL_MODEL.clearGeneralDetails(item));
        // Reset category selections
        setSelectedCategory([]);
        setSelectedSubCategory([]);
        setEmptyFields(false);
    };
    // Clears all technical details fields
    const handleClearTechnicalDetails = () => {
        setItem(EQUIPMENT_AND_MATERIAL_MODEL.clearTechnicalDetails(item));
        setEmptyFields(false);
    };
    // Base request body used to create a category
    const createCategoryBody = getCreateCategoryBody(contractorId);
    // Base request body used to create a subcategory
    const createSubcategoryBody = getCreateSubcategoryBody(contractorId);
    // Creates a new category or subcategory and refreshes the list
    const handleCreateSubcategoryCategory = async (body) => {
        return await createCategoryOrSubcategory({
            body,
            contractorId,
            dispatch,
            onSuccess: () => toast.success(t('has_been_created_successfully')),
            onError: (code) => {
                errorMsg(code);
                if(body?.type ===  CATEGORY_TYPE.CATEGORY){
                    setSelectedCategory([]);
                }else{
                    setSelectedSubCategory([]);
                }
            },
        });
    };
    // Searches subcategories using a keyword
    const handleSearchSubcategory = async (key) => {
        return await searchSubcategories({
            key,
            contractorId,
            dispatch,
        });
    };
    // Searches categories using a keyword
    const handleSearchCategory = async (key) => {
        return await searchCategories({
            key,
            contractorId,
            dispatch,
        });
    };

    return {
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleCreate,
        t,
        photoPickerFile,
        setPhotoPickerFile,
        disabled,
        item,
        emptyFields,
        handleChange,
        handleOnBack,
        setIsValid,
        setEmptyFields,
        selectedCategory,
        setSelectedCategory,
        selectedSubCategory,
        setSelectedSubCategory,
        dispatch,
        handleClearTechnicalDetails,
        handleClearGerneralDetails,
        createSubcategoryBody,
        handleCreateSubcategoryCategory,
        createCategoryBody,
        contractorId,
        handleSearchSubcategory,
        handleSearchCategory,
        categoryOptions,
        setCategoryOptions,
        subCategoryOptions,
        setSubCategoryOptions,
    };
};

export default CreateEquipmentMaterialApp;
